export enum FieldType {
    STRING='STRING',
    ALPHA_STRING='ALPHA_STRING',
    PASSWORD='PASSWORD',
    TEXT_AREA='TEXT_AREA',
    NUMBER='NUMBER',
    INTEGER='INTEGER',
    YEAR='YEAR',
    EMAIL='EMAIL',
    DATE='DATE',
    TIME='TIME',         //down to minutes
    DATETIME='DATETIME', //down to minutes
    DATETIME_DOWN_TO_SECONDS='DATETIME_DOWN_TO_SECONDS',
    DATETIME_DOWN_TO_MILLIS='DATETIME_DOWN_TO_MILLIS',
    AMOUNT='AMOUNT',
    CHIPSET='CHIPSET',
    OPTION='OPTION',
    LIST='LIST', 
    MULTI_OPTION='MULTI_OPTION',
    CHECKBOX_GROUP='CHECKBOX_GROUP',
    RADIO_GROUP='RADIO_GROUP',
    CHECKBOX_TREE='CHECKBOX_TREE',
    CHECKBOX='CHECKBOX',
    ACKNOWLEDGEMENT_CHECKBOX='ACKNOWLEDGEMENT_CHECKBOX', //only true value admitted checkbox 
    SLIDE_TOGGLE='SLIDE_TOGGLE',
    FILE='FILE',
    IMAGE='IMAGE',
    AVATAR='AVATAR',
    BOOLEAN='BOOLEAN',
    PHONE='PHONE',
    LOV='LOV'
}
